import BootstrapTable from 'react-bootstrap-table-next';
import styles from './MyBrands.module.scss';
import { upperFirst } from 'lodash';
import history from '../../../utils/history';
import { useSelector } from 'react-redux';
import { DATE_FORMAT_US } from '../../../constants/dateFormats';
import { format } from 'date-fns';

export function BrandsTable({ openAcceptInvitationModal }) {
  const { suppliers, invitations } = useSelector((state) => state.adminBrands);
  const { retailerId } = useSelector((state) => state.role);

  const formatImage = (cell, row) => {
    return (
      <div className={styles.imageWrapper}>
        <img src={cell} alt={row.model} className={styles.image} />
      </div>
    );
  };

  const suppliersData = suppliers.map((seller) => {
    const { supplier } = seller;
    return {
      supplierId: supplier.id,
      logo: supplier.square_logo_path,
      name: supplier.name,
      status: seller.status,
      date: format(new Date(seller.created_at), DATE_FORMAT_US),
    };
  });

  const invitationsData = invitations.map((invitation) => {
    const { supplier } = invitation;
    return {
      supplierId: supplier.id,
      logo: supplier.logo_path,
      name: supplier.name,
      status: 'Invited',
      date: format(new Date(invitation.created_at), DATE_FORMAT_US),
      invitation: true,
      supplier,
    };
  });

  const columns = [
    {
      text: 'Logo',
      dataField: 'logo',
      formatter: formatImage,
    },
    {
      text: 'Name',
      dataField: 'name',
    },
    {
      text: 'Status',
      dataField: 'status',
      formatter: (cell, row) => {
        if (cell !== 'activated') {
          return upperFirst(cell);
        }

        return <strong>{upperFirst(cell)}</strong>;
      },
    },
    {
      text: 'Date',
      dataField: 'date',
    },
    {
      text: 'Actions',
      idDummyField: true,
      dataField: 'invitation',
      formatter: (isInvitation, row) => {
        let title = 'Edit';
        if (isInvitation) title = 'Accept Invitation';
        if (row.status === 'pending') title = '-';

        return (
          <span
            className={styles.actionButton}
            onClick={() => {
              if (row.status === 'pending') return;
              if (isInvitation) return openAcceptInvitationModal(row.supplier);

              history.push(`/retailers/${retailerId}/admin/activation/${row.supplierId}`);
            }}
          >
            {title}
          </span>
        );
      },
    },
  ];

  return (
    <div className={styles.brandsTable}>
      <BootstrapTable
        data={suppliersData.concat(invitationsData)}
        columns={columns}
        keyField="supplierId"
        striped
        bordered={false}
        hover
      />
    </div>
  );
}
